<template>
  <div id="app" data-test="app" :key="remountKey">
    <transition>
      <router-view />
    </transition>
  </div>
</template>

<script lang="lang">
import GoogleAnalytics from "@/utils/googleAnalytics.js";
import { localeData } from "moment";

// EJS GRID TRANSLATION CODE
import Vue from "vue";
import {
  GridPlugin,
} from "@syncfusion/ej2-vue-grids";
import { L10n, setCulture } from "@syncfusion/ej2-base";
setCulture("fr");
L10n.load({
  fr: {
    grid: {
      EmptyRecord: "Aucun enregistrement à afficher",
      EmptyDataSourceError:
        "DataSource ne doit pas être vide lors du chargement initial car les colonnes sont générées à partir de dataSource dans AutoGenerate Column Grid",
      Item: "article",
      Items: "articles",
      Pdfexport: "Exportation pdf",
      Excelexport: "Exportation excel",
      Search: "recherche",
      Print: "Imprimer"
    },
    pager: {
      pagerDropDown: "objets par page",
      currentPageInfo: "{0} page sur {1}",
      totalItemsInfo: "({0} éléments)",
      firstPageTooltip: "Aller à la première page",
      lastPageTooltip: "Aller à la dernière page",
      nextPageTooltip: "Aller à la page suivante",
      previousPageTooltip: "Aller à la page précédente",
      nextPagerTooltip: "Aller aux éléments suivants du téléavertisseur",
      previousPagerTooltip: "Accéder aux éléments de téléavertisseur précédents",
    },
  },
});

Vue.use(GridPlugin);

export default {
  name: "AppComponent",
  components: {

  },
  data(){
    return {
      transitionName: '',
      windowLoc: window.location.hostname.split(".")[0],
      remountKey: 1,
    }
  },
  mounted() {
    const favicon = document.getElementById("favicon");
    // console.log(favicon.href);
    if (this.windowLoc == 'interswitchenergy') {
        favicon.href = "/iswitch_a.jpg"
    } else if (this.windowLoc == 'rainoil') {
      favicon.href = "/rainoil_1a.jpg"
    } else if (this.windowLoc == 'eterna') {
      favicon.href = "/Eterna-logo_1a.jpg"
    } else if (this.windowLoc == 'bovas') {
      favicon.href = "/bovas_1a.png"
    } else {
      favicon.href = "https://app.epump.com.ng/Content_v3/Images/favs/favicon.ico"
    }

  },
  computed: {
    checkNavbarMenu() {
      return this.$store.getters.getMobileNavDrawer;
    },
  },
  created() {
    // remounting all component event hub
    this.$eventHub.$on("remountCom", () => {
      // console.log("remounting.....");
      this.remountAll();
    });
  },
  updated() {
    new GoogleAnalytics()
  },
  async beforeMount() {
    const locale = localStorage.getItem("locale") || "en-NG";
    this.$root.$i18n.locale = locale;
    // const dateColor = localStorage.getItem('color') ? localStorage.getItem('color') : '#370f70'
    // this.$store.commit("setDatePickerColor", dateColor);

    // let locale

    // if (localStorage.getItem("locale")) {
    //   locale = localStorage.getItem("locale")
    // } else {
    //   const language = navigator.language.split('-')
    //   let country

    //   try {
    //     const res = await this.axios.get('https://geolocation-db.com/json/')
    //     if (res.data.country_code) {
    //       country = res.data.country_code
    //     }
    //   }
    //   catch (e) {

    //   }

    //   if (!country) {
    //     country = 'NG'
    //   }
    //   locale = `${language[0]}-${country}`
    // }
    // console.log(locale)
    // const splitLocale = locale.split('-')
    // this.$store.commit("setLanguage", splitLocale[0])
    // this.$store.commit("setCountry", splitLocale[1])
    // this.$root.$i18n.locale = locale;
  },
  methods: {
    //remounting all component function
  remountAll() {
    this.remountKey += 1;
  }

  }
};
</script>

<style lang="scss">
@import "@/assets/sass/styles.scss";
@import url("https://cdn.syncfusion.com/ej2/material.css");
</style>
